<template>
    <main-banner
        :title="$t('games.cricket_banner_title')"
        players="2 - 4"
        :difficulty="$t('game_difficulty.medium')"
        :image="imageSrc"
        id="cricket"
        @start-game="selectMatch('Tactics')"
        :coming-soon="false"
    />
</template>

<script>
import MainBanner from './Main.vue'
// TODO: replace with dedicated cricket banner image once available
import img from '@images/games/cricket/BannerBackground.jpg'
import { mapStores } from 'pinia'
import { useMatchStore } from '@/stores/match.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
    components: {
        MainBanner,
    },
    props: {
        online: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useMatchStore, useAuthStore),
        imageSrc() {
            return img
        },
    },
    methods: {
        async selectMatch(type) {
            await this.matchStore.selectMatchType(
                type,
                this.authStore,
                this.$router,
                this.$toast,
                this.online,
            )
        },
    },
}
</script>
